<!-- index-page -->
<template>
<div class="index-page">
  <el-container class="content-box">
    <!-- 固定头部标签栏 fixedMenu -->
    <el-header height="48px">
      <fixed-menu :name="name" :showSearch="showSearch" :menuData="menuData" :currentMidC="currentMid" :showAside="showAside" :showAsideImg="showAsideImg" @changeShowAside="changeShowAside" @update:currentMidC="currentMidC => currentMid = currentMidC" @getSearchData="getSearchData" @logout="logout"></fixed-menu>
    </el-header>
    <!-- 内容 -->
    <el-container class="content-sub-box" v-show="!tokenOverdue">
      <!-- 固定头部标签栏 sliderMenu -->
      <div v-show="showAside && indexId !== -1">
        <slider-menu :textData="textData" v-loading="loadingSlider" @chooseId="chooseId"></slider-menu>
      </div>
      <!-- index市场页 appMarket -->
      <app-market class="app-market" v-show="indexId===-1" :marketData="marketData" @clickMarket="clickMarket"></app-market>
      <div v-show="indexId!==-1" class="tabBox" :class="showAside ? 'slider-o' : 'slider-c'">
        <!-- tabBox 选项卡 -->
        <tab-box @openFullScreen="openFullScreen" :showArray="showArray" :indexIdC="indexId" @update:indexIdC="indexIdC => indexId = indexIdC" @closeIframe="closeIframe" @closeAllTabs="closeAllTabs" @closeOtherTabs="closeOtherTabs"></tab-box>
        <div class="frame-box">
          <!-- indexList首页页签 -->
          <index-list class="index-full-item" v-loading="loadingIndex" :cls="cls" v-show="indexId===0" :contentData="contentData" @chooseId="chooseId"></index-list>
          <!-- frame报表页签 -->
          <div class="iframe-box" v-for="item in showArray" :key="item.id" v-show="indexId===item.id">
            <iframe class="iframe-full-item" :class="{'iframe-full-item-active':indexId===item.id}" :src="getFramePath(item.path)" frameborder="0"></iframe>
          </div>
        </div>
      </div>
    </el-container>
    <!--过期账号提示 -->
    <div class="search-none" v-show="tokenOverdue">
      <img class="search-noneImg" :src="dataNone">
      <p>账号已过期，请重新<router-link to="/login">登录</router-link></p>
    </div>
  </el-container>
</div>
</template>
<script type="text/ecmascript-6">
import fixedMenu from 'components/fixedMenu'
import sliderMenu from 'components/sliderMenu'
import indexList from 'components/indexList'
import appMarket from 'components/appMarket'
import tabBox from 'components/tabBox'
import {leftIn, leftOut, leftHoverIn, leftHoverOut, dataNone} from '@/utils/imgUrl'
import {getSliderMenu, getGuessData, getSearchData, checkSessionTimeout} from 'utils/api/index'
import {logout, getApiToken} from 'utils/api/login'
import {getCookie, dealMenuData, getTheToken, changeParams} from 'utils/util'
import dataTracking from 'utils/dataTracking'
import Cookies from 'js-cookie'

import {  index_marketMid, index_jumpToLogin ,index_jumpToIndex,index_decisionLogin,index_decisionLogout} from "../env_config.js"


let hash = {}
export default {
  data () {
    return {
      tokenOverdue: false, // token过期
      showAside: true, // 显示侧边栏
      loadingSlider: false,
      loadingIndex: false,
      showAsideImg: leftOut, // 显示侧边栏状态
      dataNone, // 无数据icon
      allData: [], // 所有报表数据
      textData: [], // slider数据
      menuData: [], // fixed-menu数据
      currentMid: 0, // 选中报表id
      indexId: 0, // 选中页签id,0为首页
      cls: 'index', // 选中页签类型， 'index', 'search'
      showArray: [], // 页签数组
      contentData: [], // 猜你想看或搜索数据
      marketData: [], // 应用市场数据
      name: '', // fixed-menu的欢迎名字
      // 生产环境
      // marketMid: 1085634561, // 应用市场mid
      // jumpToLogin: 'http://domp.bluemoon.com.cn/bd-portal-view/index.html#/login',
      // jumpToIndex: 'http://domp.bluemoon.com.cn/bd-portal-view/index.html#/index',
      // decisionLogin: 'https://bmreport.bluemoon.com.cn/webroot/decision/login/cross/domain',
      // decisionLogout: 'https://bmreport.bluemoon.com.cn/webroot/decision/logout/cross/domain',
      // 测试环境
      marketMid: index_marketMid, // 测试环境 应用市场mid
      jumpToLogin: index_jumpToLogin,
      jumpToIndex: index_jumpToIndex,
      decisionLogin:index_decisionLogin,
      decisionLogout: index_decisionLogout,
      showSearch: true
    }
  },
  methods: {
    // 改变slider状态图标图片路径，fixedMenu
    changeShowAside (isShow, event) {
      this.showAside = isShow
      this.showAsideImg = (event === 'click') || (event === 'outHover') ? (isShow ? leftOut : leftIn) : (isShow ? leftHoverOut : leftHoverIn)
    },
    // 搜索字段返回数据，searchReport，api
    getSearchData (searchData) {
      if (searchData !== '' && searchData !== null) {
        this.loadingIndex = true
        let config = {
          'method': 'm014_6',
          token: getCookie('token'),
          userId: getCookie('dopm_user_name'),
          'menuName': searchData
        }
        getSearchData(config).then(res => {
          this.loadingIndex = false
          this.cls = 'search'
          this.indexId = 0
          if (res.respData.length) {
            this.contentData = res.respData || []
          } else {
            this.contentData = []
          }
        }).catch(() => {
          this.loadingIndex = false
        })
      } else {
        this.getGuessFunction()
        this.indexId = 0
        this.cls = 'index'
      }
    },
    // 猜你想看加载, indexList, api
    getGuessFunction () {
      this.loadingIndex = true
      let parmas2 = {
        token: getCookie('token'),
        method: 'm014_3',
        userId: getCookie('dopm_user_name')
      }
      getGuessData(parmas2).then(res => {
        if (res.respCode === '100') {
          this.contentData = res.respData
          this.loadingIndex = false
        }
      }).catch(() => {
        this.loadingSlider = false
      })
    },

    checkSessionTimeout () {
      const _this = this
      let parmas = {
        token: getCookie('token')
      }
      checkSessionTimeout(parmas).then(res => {
        if (res.respCode === '-1') {
          window.location.href = _this.jumpToLogin
          window.location.reload()
        }
      }).catch(() => {
        console.log('getSessionToken error')
      })
    },
    // 选择具体报表展示，sliderMenu/indexList ，hash去重
    chooseId (mid, path, name) {
      this.checkSessionTimeout()
      let href = location.href
      // 埋点url处理-*不需要*
      // let trackItems = {
      //   '_token': getCookie('token'),
      //   'campaign': name,
      //   'adTag': '?'
      // }
      // for (let i in trackItems) {
      //   console.log(i, trackItems[i])
      //   href = changeParams(href, i, trackItems[i])
      // }
      // location.href = href
      if (path !== null && path !== '' && path !== undefined) {
        this.indexId = mid
        let tmp = {
          id: mid,
          path,
          name
        }
        for (let i of this.showArray) {
          if (!hash[i.id]) {
            hash[i.id] = 1
          }
        }
        if (!hash[mid]) {
          this.showArray.push(tmp)
        }
        // 设置埋点
        dataTracking('btn', {
          'userid': getCookie('dopm_user_name'),
          'time': Date(),
          'url': path,
          'menuid': mid,
          'menucode': ''
        })
      }
    },
    getFramePath (path) {
      return getTheToken(path)
    },
    // 全屏展开报表 tabBox
    openFullScreen () {
      let element
      if (this.indexId === 0) {
        element = document.getElementsByClassName('index-full-item')[0]
      } else {
        element = document.getElementsByClassName('iframe-full-item-active')[0]
      }
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen()
      }
    },
    // 关闭某报表 tabBox
    closeIframe (id) {
      let arr = this.showArray
      let len = arr.length - 1
      for (let i = arr.length - 1; i >= 0; i--) {
        if (arr[i].id === id) {
          arr.splice(i, 1)
          this.showArray = arr
          hash[id] = null
          if (arr.length > 0) {
            if (i >= 1) {
              this.indexId = arr[i - 1].id
            } else {
              this.indexId = 0
            }
          } else {
            this.indexId = 0
          }
        }
      }
    },
    // 关闭所有报表，tabBox
    closeAllTabs () {
      this.showArray = []
      hash = {}
    },
    // 关闭其他报表，tabBox
    closeOtherTabs (id) {
      let arr = this.showArray
      let res = []
      hash = {}
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].id === id) {
          res.push(arr[i])
          hash[id] = 1
        }
      }
      this.showArray = res
    },
    // 退出登录，fixedMenu-api
    logout () {
      const _this = this
      this.$confirm('确定要注销账户吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.logoutFinereport()
        logout().then(res => {
          window.location.href = _this.jumpToLogin
          Cookies.remove('name')
          Cookies.remove('dopm_user_name')
          Cookies.remove('dopm_user_password')
          Cookies.remove('token')
        }).catch(() => {
          window.location.href = _this.jumpToLogin
        })
      })
    },
    // 登陆帆软的报表系统
    loginFinereport () {
      const _this = this
      this.$jsonp(this.decisionLogin,
        {
          fine_username: getCookie('dopm_user_name'),
          fine_password: getCookie('token'),
          validity: -2,
          callback: 'callback'
        }, 5000).then(json => {
        // 返回数据 json， 返回的数据就是json格式
        console.log(json)
      }).catch(err => {
        console.log(err)
      })
    },

    // 登出帆软的报表系统
    logoutFinereport () {
      const _this = this
      this.$jsonp(this.decisionLogout,
        {
          callback: 'callback'
        }, 3000).then(data => {
        // 返回数据 json， 返回的数据就是json格式
        console.log(data)
        _this.loginFinereport()
      }).catch(err => {
        console.log(err)
        _this.loginFinereport()
      })
    },
    // 点击应用市场 fixedMenu
    clickMarket (id) {
      const {href} = this.$router.resolve({
        name: 'Market',
        query: {
          id
        }
      })
      window.open(href)
    },
    // 侧边栏菜单加载 sliderMenu-api
    getTheData () {
      this.name = Cookies.get('name')
      const _this = this
      if (getCookie('token')) {
        let parmas = {
          token: getCookie('token'),
          method: 'm006_4',
          userId: getCookie('dopm_user_name')
        }
        this.loadingSlider = true
        getSliderMenu(parmas).then(res => {
          if (res.respCode === '100') {
            if (res.respData) {
              this.allData = res.respData
              console.log()
              this.menuData = dealMenuData(res.respData, 'fixed')
              this.textData = dealMenuData(res.respData, 'slider', '')
              this.marketData = dealMenuData(res.respData, 'slider', this.marketMid)
              console.log("获取菜单。。");
              console.log(this.marketData)
              this.currentMid = this.menuData[0].mid
              this.loadingSlider = false
            } else {
              this.tokenOverdue = true
            }
          }
        }).catch(() => {
          this.loadingSlider = false
        })
        this.getGuessFunction()
      } else {
        window.location.href = _this.jumpToLogin
      }
    }
  },
  created () {
    const _this = this
    // portal信任传递token处理
    if (location.href.indexOf('token=') > -1) {
      let token = location.hash.split('token=')[1].split('&')[0]
      getApiToken(token).then(res => {
        if (res.respCode === '100') {
          let dopmUserName = res.respData[0].id || ''
          let name = res.respData[0].user_name || ''
          Cookies.set('name', name, {expires: 7})
          Cookies.set('dopm_user_name', dopmUserName, {expires: 7})
          Cookies.set('token', res.token, {expires: 7})
          // 先删除后登陆
          this.logoutFinereport()
          this.getTheData()
        } else {
          window.location.href = _this.jumpToLogin
        }
      })
    } else {
      this.showSearch = false
      this.logoutFinereport()
      this.getTheData()
    }

  },
  components: {
    fixedMenu,
    sliderMenu,
    tabBox,
    indexList,
    appMarket
  },
  watch: {
    // 报表id选中后的dom变化
    currentMid () {
      if (this.currentMid === this.marketMid) {
        this.showAside = false
        this.indexId = -1
        this.showSearch = false
      } else {
        if (!this.showAside) {
          this.changeShowAside(true, 'click')
        }
        this.indexId = 0
        this.textData = dealMenuData(this.allData, 'slider', this.currentMid)
        this.showSearch = true
      }
    }
  }
}
</script>
<style lang="less">
@import '~assets/style/variable.less';
.index-page {
  height: 100%;
}
.content-sub-box {
  color: #333;
  position: relative;
}
.tabBox {
  box-shadow: 4px 4px 8px 8px rgba(204,204,204,0.5);
  position: absolute;
  left: 8px;
  right: 8px;
  bottom: 0;
  top: 8px;
}
.slider-o {
  left: 208px;
}
.slider-c {
  left: 8px;
}
.app-market {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: @color-bg-main;
}
.el-header {
  background-color: #b3c0d1;
  color: #333;
  text-align: center;
  line-height: 48px;
  padding: 0 !important;
}
.content-box {
  height: 100%;
}
.frame-box {
  background: #fff;
  position: absolute;
  bottom: 0;
  top: 36px;
  left: 0;
  right: 0;
}
body > .el-container {
  margin-bottom: 40px;
  padding: 8px;
}
.iframe-box {
  width: 100%;
  height: 100%;
  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue